import { BaseQuery } from '../base-query';
export class ValidateProjectContentQuery extends BaseQuery {
    constructor(config, queryService, identifier) {
        super(config, queryService);
        this.config = config;
        this.queryService = queryService;
        this.identifier = identifier;
    }
    toPromise() {
        return this.queryService.validateProjectContentAsync(this.getUrl(), {
            projectId: this.identifier.value
        }, this.queryConfig);
    }
    getAction() {
        return this.apiEndpoints.validateProjectContent();
    }
}
//# sourceMappingURL=validate-project-content-query.class.js.map